// Hinweiskasten im Formular (Info, Erfolg, Warnung) – Texte aus dem Code.
import type { ReactNode } from 'react';
import type { Icon } from '@phosphor-icons/react';
import { CHIP, type ChipFarbe } from './form-stil';

export function FormHinweis({ icon: I, farbe, children }: { icon: Icon; farbe: ChipFarbe; children: ReactNode }) {
  const c = CHIP[farbe];
  return (
    <div className="flex items-start" style={{
      gap: 10, padding: '10px 12px', borderRadius: 14, background: c.flaeche,
      boxShadow: `inset 0 0 0 0.5px ${c.text}40`,
    }}>
      <I aria-hidden size={15} weight="fill" color={c.text} className="shrink-0" style={{ marginTop: 1 }} />
      <div className="min-w-0 flex-1" style={{ fontSize: 12.5, fontWeight: 600, lineHeight: 1.45, color: 'rgba(255,255,255,0.78)' }}>{children}</div>
    </div>
  );
}
